export default __webpack_public_path__ + "static/media/academic.85edee4a.mp4";